import React from 'react'

import Preview from './Preview'
import cloudinaryUrl from 'src/utils/cloudinaryUrl'

const Thumb = ({ config, thumb, width, height }) =>
  <div className="ratio ratio-16x9">
    <Preview config={config} />
    {
      thumb &&
      <img
        className="img-fluid"
        src={cloudinaryUrl(thumb, {
          crop: 'limit',
          width,
          height,
          fetchFormat: 'auto',
          quality: 'auto',
        })}
        alt="Fancy background thumbnail"
      />
    }
  </div>

export default Thumb
